import { render } from "./Tyre.vue?vue&type=template&id=3e3bf566&scoped=true"
import script from "./Tyre.vue?vue&type=script&lang=js"
export * from "./Tyre.vue?vue&type=script&lang=js"

import "./Tyre.vue?vue&type=style&index=0&id=3e3bf566&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e3bf566"]])

export default __exports__